import { render, staticRenderFns } from "./popRemark.vue?vue&type=template&id=4246bb9c&scoped=true"
import script from "./popRemark.vue?vue&type=script&lang=js"
export * from "./popRemark.vue?vue&type=script&lang=js"
import style0 from "./popRemark.vue?vue&type=style&index=0&id=4246bb9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4246bb9c",
  null
  
)

export default component.exports